var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClipBadge4K = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 36.726,
  height: 10.813,
  viewBox: "0 0 36.726 10.813"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.356.03v7.278h2.122V9.33h-2.122v1.492h-4.347V9.128H1.194c-1.82 0-1.01-1.82-1.01-1.82S10.089.132 10.392.031zM12.06 2.407l-6.267 4.37h6.267zM19.16.03v10.79h4.473V6.348l7.126 4.473h5.913l-9.501-5.838L36.015.031h-5.66l-6.772 3.967V.03z"
})));
export default SvgClipBadge4K;